<template>
  <div class="bullet-text-fields">
    <div class="field">
      <label>
        Bullet text <span class="required">*</span>
        <span class="char-count" :class="{ over: textOver }">
          {{ (text || '').length }}/{{ BULLET_TEXT_MAX }}
        </span>
      </label>
      <input
        :value="text"
        :disabled="disabled"
        :maxlength="BULLET_TEXT_MAX"
        type="text"
        class="form-control"
        placeholder="Short label shown next to the icon"
        @input="$emit('update:text', $event.target.value)"
      />
    </div>

    <div class="field">
      <label>
        Alt text <span class="required">*</span>
        <span class="char-count" :class="{ over: altOver }">
          {{ (altText || '').length }}/{{ BULLET_ALT_TEXT_MAX }}
        </span>
      </label>
      <input
        :value="altText"
        :disabled="disabled"
        :maxlength="BULLET_ALT_TEXT_MAX"
        type="text"
        class="form-control"
        placeholder="Accessibility description of the icon image"
        @input="$emit('update:altText', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
import {
  BULLET_TEXT_MAX,
  BULLET_ALT_TEXT_MAX
} from '../../constants/retentionMessageTypes';

export default {
  name: 'RetentionBulletTextFields',
  props: {
    text: { type: String, default: '' },
    altText: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { BULLET_TEXT_MAX, BULLET_ALT_TEXT_MAX };
  },
  computed: {
    textOver() {
      return (this.text || '').length > BULLET_TEXT_MAX;
    },
    altOver() {
      return (this.altText || '').length > BULLET_ALT_TEXT_MAX;
    }
  }
};
</script>

<style scoped>
.bullet-text-fields {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  flex: 1;
  min-width: 0;
}

.field label {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.25rem;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.required {
  color: #ff6b6b;
}

.char-count {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.42);
  font-variant-numeric: tabular-nums;
  font-weight: 400;
}

.char-count.over {
  color: #ff8a80;
}

.form-control {
  width: 100%;
  padding: 0.45rem 0.7rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 0.85rem;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.92);
}

.form-control::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.form-control:focus {
  outline: none;
  border-color: #03B3DA;
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 0 0 2px rgba(3, 179, 218, 0.15);
}

.form-control:disabled {
  background-color: rgba(255, 255, 255, 0.02);
  color: rgba(255, 255, 255, 0.45);
  cursor: not-allowed;
}
</style>
